module.exports = __webpack_public_path__ + "static/media/13b-03_ST-2013-200x300cm-oleo-sobre-papel.1a3ae259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13b/13b-03_ST-2013-200x300cm-oleo-sobre-papel.jpg
// module id = 135
// module chunks = 0